import React, { useState, useEffect, useRef } from 'react';
import { useNavigate } from 'react-router-dom';
import { useVoucher } from './useVoucher';
import './table.scss';

const Table = ({ voucherHistory }) => {
  const navigate = useNavigate();
  const [pageNumCenterList, setPageNumCenterList] = useState([]);

  const [currentPage, setCurrentPage] = useState(null);
  const [isPhone, setIsPhone] = useState(false);

  const currentItemsPerPage = isPhone ? 7 : 5;

  const isTypeUpdate = useRef(true);
  const isPageUpdate = useRef(true);

  const totalPages = Math.ceil(voucherHistory.length / currentItemsPerPage);

  const handlePageChange = (page, tatol) => {
    if (tatol <= 3) {
      let list = []
      for (let i = 1; i <= tatol; i++) {
        list.push(i)
      }
      setPageNumCenterList(list)
      setCurrentPage(page)
    }
    else if (tatol > 3 && tatol <= 5) {
      let list = []
      for (let i = 2; i <= 4; i++) {
        list.push(i)
      }
      setPageNumCenterList(list)
      setCurrentPage(page)
    }
    else {
      let list = []
      if (page == tatol || page == tatol - 1) {
        for (let i = tatol - 3; i <= tatol - 1; i++) {
          list.push(i)
        }
      }
      else if (page == 1 || page == 2) {
        for (let i = 2; i <= 4; i++) {
          list.push(i)
        }
      }
      else {
        list = [page - 1, page, page + 1]
      }
      setPageNumCenterList(list)
      setCurrentPage(page)
    }
  }

  const getCurrentPageData = () => {
    const startIndex = ((currentPage || 1) - 1) * currentItemsPerPage;
    const endIndex = startIndex + currentItemsPerPage;
    return voucherHistory.slice(startIndex, endIndex);
  };

  useEffect(() => {
    const urlParams = new URLSearchParams(window.location.search);
    const type = urlParams.get('type')
    const page = urlParams.get('page')
    if(type && page){
      console.log(type, page);
      isPageUpdate.current = false;
      isTypeUpdate.current = false;
    }
  }, []);

  useEffect(() => {
    const PAD_BREAKPOINT = 1040;
    
    const checkScreenSize = () => {
      setIsPhone(window.innerWidth < PAD_BREAKPOINT);
    };

    checkScreenSize();
    window.addEventListener('resize', checkScreenSize);

    return () => {
      window.removeEventListener('resize', checkScreenSize);
    };
  }, []);

  useEffect(() => {
    handlePageChange(1, totalPages);
  }, [voucherHistory, isPhone]);

  return (
    <div className="cHistoryTable">
      <div className='cContentBox'>
        <div className='cNewsBox'>
          <div className='cNewsSummary'>
            <div className='cFrame'>
              <img className='pc' src={window.assetUrl('/images/voucher-page/pc/HistoryTable.png')} alt='' />
              <img className='mb' src={window.assetUrl('/images/voucher-page/mobile/HistoryTable.png')} alt='' />
            </div>
            <div className='cListBox'>
              {getCurrentPageData().map((history, index) => (
                <div key={index} className='cNewsSummaryItem'>
                  <div className='cTitleBox'>
                    <div className='cItemTitle'>
                      <label>{history?.voucher_code}</label>
                    </div>
                    <div className='cItemReward'>
                      <label>{history?.reward}</label>
                    </div>
                    <div className='cDate'>
                      <label>
                        {history?.redeemed_time?.replace(/-/g, '/').replace(/\s+/g, '\n')}
                      </label>
                    </div>
                  </div>
                </div>
              ))}
            </div>
          </div>
        </div>
        {voucherHistory.length > 0 && (
          <div className='cPageNumber'>
            <img className="cPageNumberSeparate" src={window.assetUrl('/images/news-page/page-number-separate.png')} alt="" />
            {totalPages > 3 && (
              <div className='cFirst'>
                <div className='cNum' onClick={() => { 
                  handlePageChange(1, totalPages);
                }}>
                  <img style={{ opacity: 1 === currentPage ? 1 : 0 }} src={window.assetUrl('/images/news-page/page-number-current.png')} alt="" />
                  <div className='cNumText'>1</div>
                </div>
              </div>
            )}
            <div className='cCenter'>
              {pageNumCenterList.map((num, index) => (
                <div key={index} className='cNum' onClick={() => { 
                  handlePageChange(num, totalPages);
                }}>
                  <img style={{ opacity: num === currentPage ? 1 : 0 }} src={window.assetUrl('/images/news-page/page-number-current.png')} alt="" />
                  <div className='cNumText'>{num}</div>
                </div>
              ))}
            </div>
            {totalPages > 3 && (
              <div className='cLast'>
                <div className='cNum' onClick={() => { 
                  handlePageChange(totalPages, totalPages);
                }}>
                  <img style={{ opacity: totalPages === currentPage ? 1 : 0 }} src={window.assetUrl('/images/news-page/page-number-current.png')} alt="" />
                  <div className='cNumText'>{totalPages}</div>
                </div>
              </div>
            )}
          </div>
        )}
      </div>
    </div>
  );
};

export { Table };

